var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",attrs:{"for":"type"}},[_vm._v("Último Curso")]),_vm._v(" "),_c('p',{class:_vm.lastCourse.grade_final_grade != null ? 'mb-0' : ''},[_vm._v("\n      "+_vm._s(_vm.lastCourse.course_name !== null ? _vm.lastCourse.course_name : "-")+"\n    ")]),_vm._v(" "),_c('CBadge',{staticClass:"badge-grade",attrs:{"color":_vm.lastCourse.grade_final_grade == 0
          ? 'danger'
          : _vm.lastCourse.grade_final_grade < 75
          ? 'danger'
          : _vm.lastCourse.grade_final_grade >= 75 &&
            _vm.lastCourse.grade_final_grade <= 79
          ? 'warning'
          : _vm.lastCourse.grade_final_grade > 79
          ? 'success'
          : 'danger'}},[_c('b',[_vm._v(_vm._s(_vm.lastCourse.grade_id !== 0
          ? ("Nota Final:" + (_vm.lastCourse.grade_final_grade))
          : "Aún no se registró nota del curso."))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }